import { render, staticRenderFns } from "./sessionExpired.vue?vue&type=template&id=b6f45dec&"
import script from "./sessionExpired.vue?vue&type=script&lang=js&"
export * from "./sessionExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports